/** Where to go after login: only same-app paths (`/…`, not `//host`) — no open redirect. */
export function safeNext(next: string | null | undefined, fallback = '/'): string {
  return next && next.startsWith('/') && !next.startsWith('//') ? next : fallback;
}
